export interface OrgCollapseLayoutTransition {
  expandedNodeIds: string[];
  collapsedNodeIds: string[];
}

/**
 * Returns collapse changes that are allowed to trigger auto-layout.
 * Persisted collapse state is restored before auto-layout is armed and must
 * never be interpreted as a new user action.
 */
export function computeOrgCollapseLayoutTransition(
  previousCollapsedNodeIds: string[],
  currentCollapsedNodeIds: string[],
  autoLayoutArmed: boolean,
): OrgCollapseLayoutTransition {
  if (!autoLayoutArmed) {
    return { expandedNodeIds: [], collapsedNodeIds: [] };
  }

  const previous = new Set(previousCollapsedNodeIds);
  const current = new Set(currentCollapsedNodeIds);
  return {
    expandedNodeIds: previousCollapsedNodeIds.filter((id) => !current.has(id)),
    collapsedNodeIds: currentCollapsedNodeIds.filter((id) => !previous.has(id)),
  };
}
